<template>
  <div>
    <FormBase :disabled="isLoading" v-if="!submitted" @submit.prevent="submit">
      <Heading level="2" weight="100" align="center">NAUTICUS AIRDROP</Heading>
      <p class="sub-heading">
        Expand the reach of your project by participating in the Nauticus
        Airdrop, featuring one airdrop a day for a week to the Nauticus Network
        in 50+ countries. Coming soon in November.
      </p>
      <PropGroup :disabled="isLoading" size="large" block outlined rounded>
        <template slot-scope="props">
          <InputBase
            v-validate="'required'"
            v-model="data.projectName"
            v-bind="props"
            name="projectName"
            placeholder="Project Name"
            label="What is the name of your project?"
            autofocus
          />
          <InputBase
            v-validate="'required'"
            v-model="data.companyPosition"
            v-bind="props"
            name="companyPosition"
            placeholder="Company Position"
            label="What is your name &amp; position in the company?"
          />
          <InputBase
            v-validate="'required'"
            v-model="data.projectTeamLeader"
            v-bind="props"
            name="contactInformation"
            placeholder="John Doe"
            label="Project team leader"
          />
          <InputBase
            v-validate="'required'"
            v-model="data.contactInformation"
            v-bind="props"
            name="contactInformation"
            placeholder="john@my-project.org"
            label="Contact information"
          />
          <TextareaBase
            v-validate="'required'"
            v-model="data.projectDescription"
            v-bind="props"
            name="projectDescription"
            placeholder="My project is about..."
            label="Describe your project in one sentence"
            full-width
          />
          <InputBase
            v-validate="'required|url'"
            v-model="data.projectWebsite"
            v-bind="props"
            name="projectWebsite"
            placeholder="https://www.my-project.org"
            label="Link to project website"
          />
          <InputBase
            v-validate="'required|url'"
            v-model="data.projectLatestVersion"
            v-bind="props"
            name="projectLatestVersion"
            placeholder="https://www.my-project.org/whitepaper"
            label="Link to the latest version of project’s whitepaper"
          />
          <InputBase
            v-validate="'required'"
            v-model="data.digitalAssetProtocol"
            v-bind="props"
            name="digitalAssetProtocol"
            placeholder="ERC-20"
            label="What’s the protocol of your digital asset?"
          />
          <InputBase
            v-validate="'required'"
            v-model="data.projectCompletionStatus"
            v-bind="props"
            name="projectCompletionStatus"
            placeholder="Public Sale"
            label="Completion status of your project"
          />
          <Box margin-y="3rem">
            <strong>Airdrop terms:</strong> <br />
            <ul class="terms-list">
              <li>
                The participating project will be responsible for distributing
                the airdrop tokens.
              </li>
              <li>
                Nauticus will not be responsible for any misinformation provided
                by the participating project.
              </li>
              <li>
                Nauticus will not be responsible in handling enquiries/support
                request as a part of hosting the participating project.
              </li>
              <li>
                Any confidential information disclosed by either part in
                association with this airdrop campaign will be governed by
                mutual Non-Disclosure Agreement.
              </li>
              <li>
                The participating project will be responsible for costs incurred
                taking part of the airdrop.
              </li>
            </ul>
            <CheckboxBase
              v-model="data.termsAccepted"
              name="termsAccepted"
              required
              >I agree to the terms of participating in Nauticus
              Airdrop.</CheckboxBase
            >
          </Box>
        </template>
      </PropGroup>
      <ButtonBase
        :loading="isLoading"
        type="submit"
        size="large"
        variant="primary"
        block
        rounded
        weight="100"
        >Submit</ButtonBase
      >
      <transition-group name="fade">
        <template v-if="errored">
          <Box key="boxiebox" margin-y="20px" />
          <Alert key="alertiealert" variant="error">
            Something went wrong. Contact support at
            <a href="mailto:support@nauticus.exchange"
              >support@nauticus.exchange</a
            >
          </Alert>
        </template>
      </transition-group>
      <LinkList>
        <li><a href="/privacy-policy" target="_blank">Privacy Policy</a></li>
      </LinkList>
    </FormBase>
    <Panel v-else rounded padding="30px">
      <Heading level="3" weight="400" align="center"
        >Your form has been submitted</Heading
      >
      <p class="sub-heading">
        Thank you for your submission. We will contact you via the information
        you've provided.
      </p>
    </Panel>
  </div>
</template>

<script>
import {
  Alert,
  Box,
  ButtonBase,
  CheckboxBase,
  FormBase,
  Heading,
  InputBase,
  LinkList,
  PropGroup,
  TextareaBase,
  Panel,
} from '@nauticus-blockchain/nauticus-ui'
export default {
  name: 'RegisterForm',
  provideValidator: true,
  inject: ['$validator'],
  $_veeValidate: { events: 'input' },
  components: {
    Alert,
    Box,
    ButtonBase,
    CheckboxBase,
    FormBase,
    Heading,
    InputBase,
    LinkList,
    PropGroup,
    TextareaBase,
    Panel,
  },
  data() {
    return {
      data: {},
      submitted: false,
      errored: false,
      isLoading: false,
    }
  },
  computed: {
    airdropAgreementUrl() {
      return `${process.env.BASE_URL ||
        '/airdrop/'}docs/Nauticus-Airdrop-Agreement.pdf`
    },
  },
  methods: {
    async submit() {
      try {
        this.isLoading = true
        const resp = await fetch(process.env.VUE_APP_ZAPIER_API_URL, {
          method: 'POST',
          body: JSON.stringify(this.data),
        })
        const jsonData = await resp.json()
        this.isLoading = false
        if (jsonData.status) {
          this.errored = false
          this.submitted = true
        } else {
          this.errored = true
        }
      } catch (_err) {
        this.isLoading = false
        this.errored = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@nauticus-blockchain/nauticus-ui/src/assets/styles/mixins';

.heading {
  margin: 0 auto 4rem auto;
}

.sub-heading {
  text-align: center;
}

.terms-list {
  color: #dddddd;
  margin-bottom: 26px;
}

@include transitionFade;
</style>
